export const GOI_COMPANY_ADDRESS = "서울시 관악구 신림로 132, 1,2,3층";

/** 감사보고서 PDF. 실물은 platform.goifuneral.co.kr/public/ 에 있고 www 로 서빙된다. 매년 교체. */
export const GOI_AUDIT_REPORT_URL =
  "https://www.goifuneral.co.kr/report-2025.pdf";
